import React, { useState } from 'react'
import cn from 'classnames'
import { format } from '../utils/number'
import { useModal } from '../hooks/modal'
import { checkForAdmin, checkPermission as cp } from '../utils/auth'
import StudentPayment from './StudentPayment'
import StudentInfo from './StudentInfo'
import Loader from './common/Loader'
import { usePutRequest } from '../hooks/request'
import { STUDENT_DETAIL } from '../urls'


export default function StudentItem({ item, onPaymentCreate, onSuccess, index }) {
    const isAdmin = checkForAdmin()
    const studentUpdate = usePutRequest({ url: STUDENT_DETAIL.replace('{id}', item.id) })
    const [showDropdown, setShowDropdown] = useState(false)
    const [editingNote, setEditingNote] = useState(false)
    const [noteValue, setNoteValue] = useState(item.note || '')

    const [showPaymentModal, hidePaymentModal] = useModal(
        <StudentPayment
            onSuccess={() => {
                hidePaymentModal()
                onPaymentCreate()
            }}
            student={item} />,
    )

    const [showInfoModal, hideInfoModal] = useModal(
        <StudentInfo
            onCancel={() => hideInfoModal()}
            customer={item.customer} />,
    )

    async function onStatusChange() {
        const data = { ...item, isActive: !item.isActive, group: item.group.id, customer: item.customer.id }
        const { success } = await studentUpdate.request({ data })
        if (success) {
            onSuccess()
            window.location.reload()
        }
    }

    async function saveNote() {
        const data = { ...item, group: item.group.id, customer: item.customer.id, note: noteValue }
        const { success } = await studentUpdate.request({ data })
        if (success) {
            setEditingNote(false)
            onSuccess()
        }
    }

    // Задолженность: price - monthPaid (показываем только если есть долг)
    const debt = (item.price || 0) - (item.monthPaid || 0)

    return (
        <tr className={cn({ 'has-text-grey': !item.isActive })}>
            <td>{index + 1}</td>
            <td className="pointer" onClick={showInfoModal}>{item.customer.name}</td>
            <td className="pointer">{item.customer.phone}</td>
            <td>{format(item.price || 0)}</td>
            <td>{format(item.monthPaid || 0)}</td>
            <td>
                {debt > 0 ? (
                    <span className="has-text-danger">{format(debt)}</span>
                ) : (
                    <span className="has-text-success">0</span>
                )}
            </td>
            <td>
                {editingNote ? (
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <input
                            className="input is-small"
                            value={noteValue}
                            onChange={(e) => setNoteValue(e.target.value)}
                            placeholder="Примечание..."
                            style={{ minWidth: '120px' }}
                        />
                        <i className="icon pointer ion-md-checkmark has-text-success" onClick={saveNote} />
                        <i className="icon pointer ion-md-close has-text-danger" onClick={() => { setEditingNote(false); setNoteValue(item.note || '') }} />
                    </div>
                ) : (
                    <span className="pointer" onClick={() => setEditingNote(true)} style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        {item.note || <span className="has-text-grey-light is-italic" style={{ fontSize: '12px' }}>добавить...</span>}
                        <i className="icon ion-md-create" style={{ fontSize: '14px' }} />
                    </span>
                )}
            </td>

            <td>
                {isAdmin && (
                    <div
                        className={cn('dropdown is-right', { 'is-active': showDropdown })}
                        onMouseLeave={() => setShowDropdown(false)}>
                        <div className="dropdown-trigger pointer">
                            <i className="icon ion-md-more" onClick={() => setShowDropdown(!showDropdown)} />
                        </div>

                        <div className="dropdown-menu">
                            <div className="dropdown-content">
                                {cp('finance.add_student_payment') ? (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a className="pointer dropdown-item" onClick={showPaymentModal}>
                                        <i className="icon ion-md-cash" />
                                        Оплата
                                    </a>
                                ) : null}

                                {!studentUpdate.loading ? (
                                    <span>
                                        {cp('finance.change_wallet') && !item.isActive ? (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a className="dropdown-item" onClick={onStatusChange}>
                                                <i className="icon ion-md-checkmark" />
                                                Не активным
                                            </a>
                                        ) : (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a onClick={onStatusChange} className="dropdown-item">
                                                <i className="icon ion-md-checkmark" />
                                                Активный
                                            </a>
                                        )}
                                    </span>
                                ) : <Loader center />}
                            </div>
                        </div>
                    </div>
                )}
            </td>
        </tr>
    )
}
